var exports = {
  "Y": "xaf9ae18d--079d92--infrastructure-rows",
  "F": "xaf9ae18d--079d92--non-clickable-heading-wrapper",
};

module.exports = exports;
